import React from 'react'
import { ThemeProvider, CssBaseline } from '@mui/material'

import { getTheme } from './theme'
import { useAppSelector } from './app/hooks'
import { ZoneTheme } from './shared/types'

interface Props {
  children: React.ReactNode
}

export const DynamicThemeProvider: React.FC<Props> = ({ children }) => {
  const { data: zoneData } = useAppSelector((state) => state.zone)

  const theme = React.useMemo(() => {
    let customTheme: ZoneTheme = {}
    if (zoneData?.theme) {
      customTheme = {
        grayscaleImages: zoneData?.theme?.grayscaleImages || false,
      }
    }
    return getTheme(customTheme)
  }, [zoneData])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
